import "./Locations.module.css";
import Header from "@/reusable_sections/Header";
import WorkDirectory from "./sections/WorkDirectory";
import Footer from "@/reusable_sections/Footer";
export default function LocationsPage() {
  return <div>
      <Header />
      <WorkDirectory />
      <Footer />
    </div>;
}